// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1b55a24f","488":"7213179a","977":"c3d99690"}[chunkId] + ".chunk.js";
};